import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: { conversationLoading: boolean } = {
  conversationLoading: false,
};

const conversationSlice = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    setConversationLoading: (state, action: PayloadAction<boolean>) => {
      state.conversationLoading = action.payload;
    },
  },
});

export const { setConversationLoading } = conversationSlice.actions;
export default conversationSlice.reducer;
